export default __webpack_public_path__ + "static/media/picture3.0cd68b72.jpeg";